module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAATxJREFUSA3tlr9OwzAQxr8zEQMjYmHkBRADr8BCF9Z26FMgIbWoQpCi8g5MTB2ztK+CxMbEwsbIn+O7KIeiphbQmAXVUWL7Ev/uvnMSW3Chm3jDJRR9nrtYtQieOfQQY3msI0IJ/8BZK7gRFTu8Fgx4q+4gKyM3S0AHuczrN3/UHqhWzz2QdYBX3LLf87HhK/JV4E6xOuCE1xfyuhjqqd8K3mhd53JPJ31ylMcEIz0yZjoHRsulgOCKrQ28Y4pz3cvMnqT4XPiMKLappEiroBnpfnsF1yJNLi2VoriDoc4o8Xjp4EWjYM4PrLNotn6qFHnmGz7iCiIRNQjfGFIpiLqJK1jPQZW09Rz42/OPv4PA//dTqXOgS/8lnoNf1c4iW7goTGCL/l+UgJsMGUbcWdhC127bUg/QsiK4M/YnK1ZYANPczh4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-lydh.png
// module id = 424
// module chunks = 2